export const SubtasksRoutes = {
    Reply: "Subtask/Reply",
    AcceptInvitation: "Subtask/AcceptInvitation",
    GetCorrespondence: "Subtask/GetCorrespondence",
    GetSubtaskType: "Subtask/GetSubtaskType",
    GetSubtask: "Subtask/GetSubtask",
    GetSubtaskByVesselMou: "Subtask/GetSubtaskByVesselMou",
    SaveSubtaskType: "Subtask/SaveSubtaskType",
    DeleteSubtaskTypes: "Subtask/DeleteSubtaskTypes",
    SetAsReviewed: "Subtask/SetAsReviewed",
    SetVetTaskAsReviewed: "Subtask/SetVetTaskAsReviewed",
    SetAsClosed: "Subtask/SetAsClosed",
    GetCorrespondenceForEntity: "Subtask/GetCorrespondenceForEntity",
    GetCorrespondenceCountsForEntity: "Subtask/GetCorrespondenceCountsForEntity",
    AddSubtask: "Subtask/AddSubtask",
    AddAttachmentToEntityDocuments: "Subtask/AddAttachmentToEntityDocuments"
}